import { Button } from '@mui/material';
import { IoDiamondOutline } from 'react-icons/io5';
import { useTheme } from '../styles/theme';

const GradientButton = () => {
  const { mode } = useTheme();
  const textColor = mode === 'dark' ? 'white' : 'gray';

  return (
    <div className="button-container rounded-lg">
    </div>
  );
};

export default GradientButton;
